"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.resolveFreeAppRootRoutePath = resolveFreeAppRootRoutePath;
const app_base_contract_1 = require("./app-base-contract");
const app_base_database_requirements_1 = require("./app-base-database-requirements");
/** Allocate the same free root route for platform and local installations. */
function resolveFreeAppRootRoutePath(config, names) {
    const slug = names.map(app_base_database_requirements_1.appInstallIdentifierSlug).find(Boolean);
    if (!slug)
        return null;
    const occupied = [
        ...config.pages.map(page => page.path),
        ...(config.appBase?.routes.map(route => route.path) ?? []),
        ...(config.appComposition?.mounts.map(mount => mount.routePrefix) ?? []),
    ].map(path => path
        .trim()
        .replace(/\/{2,}/g, '/')
        .replace(/\/+$/g, '') || '/');
    const isFree = (root) => !occupied.some(path => path === root || path.startsWith(root + '/'));
    const mountPoint = (suffix) => '/' +
        slug
            .slice(0, app_base_contract_1.APP_ROUTE_SEGMENT_MAX_LENGTH - suffix.length)
            .replace(/-+$/, '') +
        suffix;
    let candidate = mountPoint('');
    for (let suffix = 2; !isFree(candidate); suffix++)
        candidate = mountPoint('-' + suffix);
    return candidate;
}
